import { memo, useEffect } from 'react'

import { Anchor, Center, Loader, Text } from '@mantine/core'

import { useGetIpData } from '@repo/common/queries/location'

import { LegalRestrictionContainer } from '@/components/LegalRestrictionContainer'
import type { BasePanelProps } from '@/flows/flow_helpers'

export const PanelLocationCheck = memo<BasePanelProps>(
  function PanelLocationCheck({ onCompleted }) {
    const ip_data_query = useGetIpData({ refetch_until_not_vpn: true })

    useEffect(() => {
      if (ip_data_query.data?.threat.is_anonymous == false) {
        onCompleted()
      }
    }, [ip_data_query.data?.threat.is_anonymous, onCompleted])

    if (ip_data_query.data?.threat.is_anonymous) {
      return (
        <LegalRestrictionContainer>
          <VPNNotAllowed />
        </LegalRestrictionContainer>
      )
    }

    return (
      <LegalRestrictionContainer>
        <Text opacity={0.7}>Checking ip...</Text>
        <Center w="100%">
          <Loader color="primary" type="bars" />
        </Center>
      </LegalRestrictionContainer>
    )
  },
)

export const useSkipLocationCheck = (): boolean => {
  const ip_data_query = useGetIpData({ refetch_until_not_vpn: true })

  return (ip_data_query.data?.threat.is_anonymous ?? true) == false
}

export const VPNNotAllowed = () => {
  return (
    <>
      <Text c="red" role="status">
        VPNs are not allowed
      </Text>
      <Text size="lg">Please disconnect from the VPN and try again</Text>
      <Text opacity={0.7}>Rechecking ip...</Text>
      <Center w="100%">
        <Loader color="primary" type="bars" />
      </Center>
      <Text opacity={0.7}>
        If you have any questions or issues please reach out to us at{' '}
        <Anchor href="mailto:hello@fission.xyz">hello@fission.xyz</Anchor>.
      </Text>
    </>
  )
}
